export class TruckerContact {
    contactId: number = 0;
    contactName: string = "";
    phone1: string = "";
    isPhone1TextEnabled: boolean = false;
    phone2: string = "";
    isPhone2TextEnabled: boolean = false;
    fax: string = "";
    email: string = "";
    notes: string = "";
    isPrimary: boolean = false;
    isPhone1Default: boolean = false;
    isPhone2Default: boolean = false;
    hasChanged: boolean = false;
    isPhone1Selected: boolean = false;
    isPhone2Selected: boolean = false;
    isEmailDefault: boolean = false;
    phone1ValidationStatus: string = 'pending';
    phone2ValidationStatus: string = 'pending';
    phone1LastValidatedDate: Date | null = null;
    phone2LastValidatedDate: Date | null = null;
}
